import { Box, Card, CardContent } from "@mui/material";
import { ProcessedCorrectionBillingDto } from "../../../../../../../api-client";
import { CorrectionBillInfoGrid } from "./CorrectionBillInfoGrid";

import { NotesField } from "../../../../DirectBilling/NewBill/components/sub-components/Notes";
import { CorrectionBillTable } from "./CorrectionBillTable";

export interface CorrectionBillCardProps {
  bill: ProcessedCorrectionBillingDto;
  account: string;
  userName: string;
  notes: string;
  onNotesChange: (val: string) => void;
  onRemoveAll: (payerIK: string) => void;
  selectedRxId: string | null;
  onRowClick: (row: any) => void;
  onMenuOpen: (event: React.MouseEvent<HTMLButtonElement>, row: any) => void;
}

export function CorrectionBillCardNew({
  bill,
  account,
  userName,
  notes,
  onNotesChange,
  onRemoveAll,
  selectedRxId,
  onRowClick,
  onMenuOpen,
}: CorrectionBillCardProps) {
  const { payer, correctionAmount, rxs, previousBillDate, previousBillNumber } = bill;
  const totalPriceFormatted = Number(correctionAmount).toFixed(2).replace(".", ",");
  const todayString = new Date().toDateString();

  return (
    <Box>
      <Card
        elevation={1}
        sx={{ borderRadius: 3 }}
      >
        <CardContent>
          <CorrectionBillInfoGrid
            payerDto={payer}
            account={account}
            userName={userName}
            totalPriceFormatted={totalPriceFormatted}
            startDate={todayString}
            handleRemoveAll={onRemoveAll}
          />
          <CorrectionBillTable
            rx={rxs}
            selectedRxId={selectedRxId}
            onRowClick={onRowClick}
            onMenuOpen={onMenuOpen}
            previousBillNumber={previousBillNumber}
            previousBillDate={previousBillDate}
          />
          <NotesField
            value={notes}
            onChange={onNotesChange}
          />
        </CardContent>
      </Card>
    </Box>
  );
}

export default CorrectionBillCardNew;
